import { computed, Injectable, inject } from '@angular/core';
import { TaskDetailsHashmapState } from '../../../../routes-with-sidebar/shared/state/task-details/task-details-hashmap.state';
import { TaskDetailsBaseUi } from '../../../../routes-with-sidebar/shared/models/task-details.model';
import { UrlParamsState } from 'src/app/routes/routes-with-sidebar/shared/state/url-params/url-params.state';

@Injectable({
  providedIn: 'root',
})
export class ActiveTaskDetailsProviderService<
  T extends TaskDetailsBaseUi = TaskDetailsBaseUi,
> {
  private readonly urlParamsState = inject(UrlParamsState);
  private readonly taskDetailsHashmapState = inject(TaskDetailsHashmapState);

  public readonly activeAccountManager = computed(() => {
    const activeTaskId = this.urlParamsState.activeTaskId();
    const activeTaskGroupId = this.urlParamsState.activeTaskGroupId();

    if (!activeTaskId) {
      return null;
    }
    // Use activeTaskGroupId if available, otherwise fallback to activeTaskId
    return this.taskDetailsHashmapState.getState(
      activeTaskGroupId || activeTaskId
    );
  });

  public activeTaskDetails = computed<T | null>(() => {
    const activeAccountManager = this.activeAccountManager();

    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.taskDetails() as T;
  });

  public activeTaskGroup = computed(() => {
    const activeAccountManager = this.activeAccountManager();

    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.taskGroup();
  });

  public activeTaskGroupId = computed<string | null>(() => {
    return this.urlParamsState.activeTaskGroupId();
  });

  public readonly loading = computed(() => {
    const activeAccountManager = this.activeAccountManager();

    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.loading();
  });

  public readonly error = computed(() => {
    const activeAccountManager = this.activeAccountManager();

    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.error();
  });
}
